function counterCheck(id) {
  var fd = $( "#site_check" ).serialize();
  
  $.ajax({
    url: 'https://hub.bathmatedirect.com/counterfeit/counter-check.php',
    data: fd,
    type: 'POST',
    success: function(data){
        
      var arr = JSON.parse(data);

      var id = arr['id'];
      var url = arr['url'];
      var domain = arr['domain'];
      var auth = arr['auth'];

      if(auth.indexOf('Y') !== -1){
          $('#auth_valid').slideDown();
      }else if(auth.indexOf('X') !== -1){
          $('#auth_invalid').slideDown();
      }else{
          $('#auth_unknown').slideDown();
      }
    }
  });
}

function siteSubmit(id) {

  var fd = $( "#site_submit" ).serialize();
  $.ajax({
    url: 'https://hub.bathmatedirect.com/counterfeit/site-submit.php',
    data: fd,
    type: 'POST',
    success: function(data){
          
      var arr = JSON.parse(data);
      var success = arr['success'];

      if(success.indexOf('Y') !== -1){
        // DO SOMETHING - LEGIT
        $('.site_submit_content').fadeOut('400', function() {

          $('#site_submit_success').fadeIn();

        });
      }

    }
  });

}

function validateEmail(emAil) {
  var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailReg.test( emAil );
}

$( document ).ready(function() {
    $("#site_check_btn").click(function(){
      $('.auth_result').slideUp();
      var sc_url = $('#sc_url').val();
      if(sc_url.indexOf('.') !== -1){
        //DO SOMETHING FOR URL
        }else{
         $('#sc_url').attr("placeholder", "Please enter a valid address");
         $('#sc_url').addClass('FormError');
        return false;
      }

    	counterCheck();
    });

    $("#site_submit_btn").click(function(){

      var error_count = 0;

      var ss_name = $('#ss_name').val();
      if(ss_name.length < 2){
        //DO SOMETHING FOR NAME 
         $('#ss_name').attr("placeholder", "Please enter your name");
         $('#ss_name').addClass('FormError');
        error_count = (error_count*1)+1;
      }

      var ss_email = $('#ss_email').val();
      if(validateEmail(ss_email)){
      }
      else{
        //DO SOMETHING FOR EMAIL
         $('#ss_email').attr("placeholder", "Please enter a valid email address");
         $('#ss_email').addClass('FormError');
        error_count = (error_count*1)+1;
      }

      var ss_url = $('#ss_url').val();
      if(ss_url.indexOf('.') !== -1){
      }else{
        //DO SOMETHING FOR URL
         $('#ss_url').attr("placeholder", "Please enter the website's URL");
         $('#ss_url').addClass('FormError');
        error_count = (error_count*1)+1;
      }

      if(error_count > 0){
        return false;
      }

      siteSubmit();

    });

  $('input').click(function(){
    $(this).removeClass('FormError');
    $(this).attr('placeholder','');
  });

  $('input').on('input', function(){
    $(this).removeClass('FormError');
    $(this).attr('placeholder','');
  });

  $('#site_resubmit_btn').click(function(){
    $('#site_submit input,#site_submit textarea').val('');
    $('#site_submit_success').fadeOut('400', function() {
      $('.site_submit_content').fadeIn();
    });
  });

  $('#site_check input').on('input', function() {
        $(".auth_result").slideUp();
  });

  $(document).keypress(function(e) {
    var keycode = (e.keyCode ? e.keyCode : e.which);
    if (keycode == '13') {
       e.preventDefault();
      if ($("#site_submit input").is(":focus")) {
        $("#site_submit_btn").click();
      }
      else if($("#site_check input").is(":focus")){
        $("#site_check_btn").click();
      }
    }
  });

});
